export const FooterMenu = [
  {
    items: [
      {
        label: '一般のニュース',
        url: 'https://jp.benzinga.com/news',
      },
      {
        label: '日本のニュース',
        url: 'https://jp.benzinga.com/news/japan',
      },
      {
        label: '米国のニュース',
        url: 'https://jp.benzinga.com/news/USA',
      },
      {
        label: 'アジアのニュース',
        url: 'https://jp.benzinga.com/news/global/asia',
      },
      {
        label: 'ヨーロッパのニュース',
        url: 'https://jp.benzinga.com/news/global/Europe',
      },
    ],
    label: 'ニュース',
  },
  {
    items: [
      {
        label: '寄付する',
        url: 'https://jp.benzinga.com/contribute-to-benzinga/',
      },
      {
        label: 'ライセンス',
        url: 'https://jp.benzinga.com/benzinga-japan%e3%81%ab%e3%81%a4%e3%81%84%e3%81%a6/',
      },
      {
        label: 'スポンサーコンテンツ',
        url: 'https://jp.benzinga.com/benzinga-japan%e3%81%ab%e3%81%a4%e3%81%84%e3%81%a6/',
      },
      {
        label: '広告掲載',
        url: 'https://jp.benzinga.com/benzinga-japan%e3%81%ab%e3%81%a4%e3%81%84%e3%81%a6/',
      },
      {
        label: 'メディアキット請求',
        url: 'https://jp.benzinga.com/benzinga-japan%e3%81%ab%e3%81%a4%e3%81%84%e3%81%a6/',
      },
      {
        label: 'ベンジンガについて',
        url: 'https://jp.benzinga.com/benzinga-japan%e3%81%ab%e3%81%a4%e3%81%84%e3%81%a6/',
      },
    ],
    label: 'パートナーシップ',
  },
  {
    items: [
      {
        label: 'ベンジンガアメリカ',
        url: 'https://www.benzinga.com/',
      },
      {
        label: 'ベンジンガ ジャパン',
        url: 'https://jp.benzinga.com/',
      },
      {
        label: 'ベンジンガ韓国',
        url: 'https://kr.benzinga.com/',
      },
      {
        label: 'ベンジンガイタリア',
        url: 'https://it.benzinga.com/',
      },
      {
        label: 'ベンジンガスペイン',
        url: 'https://es.benzinga.com/',
      },
      {
        label: 'ベンジンガインド',
        url: 'https://in.benzinga.com/',
      },
    ],
    label: 'ベンジンガ・グローバル',
  },
];

export const FooterCopyRightLinks = [
  {
    label: 'プライバシーポリシー',
    url: 'https://jp.benzinga.com/privacy-policy/',
  },
  {
    label: '利用規約',
    url: '#',
  },
  {
    label: 'アクセシビリティ',
    url: '#',
  },
];
